module.exports = __webpack_public_path__ + "img/2.142e3672.png";